import { css } from 'styled-components'
import { applyTextStyle } from '../../styles/typography'

const TagBaseStyle = css`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 12px;
  ${applyTextStyle('label')}
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

export default TagBaseStyle
